import { render, staticRenderFns } from "./list-control-new.vue?vue&type=template&id=2529d13a&scoped=true"
import script from "./list-control-new.vue?vue&type=script&lang=ts"
export * from "./list-control-new.vue?vue&type=script&lang=ts"
import style0 from "./list-control-new.vue?vue&type=style&index=0&id=2529d13a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2529d13a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ViewMoreNew: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/view-more-new.vue').default,BtnDirectionNew: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/btn-direction-new.vue').default})
